interface UserJSON {
  avatarPath: string;
  userName: string;
  created: string;
  bio: string;
  status: string;
  id: string;
  name: string;
  avatar: string;
  enabled: boolean;
}

export class BlogUserModel {
  constructor(
    public id: string,
    public userName: string,
    public avatarPath: string,
    public bio: string,
    public status: string,
    public name: string,
    public avatar: string,
    public enabled: boolean
  ) {}

  static fromJSON(json: UserJSON | string): BlogUserModel {
    if (typeof json === 'string') {
      // if it's a string, parse it first
      return JSON.parse(json, BlogUserModel.reviver);
    } else {
      // create an instance of the User class
      const user = Object.create(BlogUserModel.prototype);
      // copy all the fields from the json object
      return Object.assign(user, json, {
        // convert fields that need converting
        created: new Date(json.created),
      });
    }
  }

  // reviver can be passed as the second parameter to JSON.parse
  // to automatically call User.fromJSON on the resulting value.
  static reviver(key: string, value: any): any {
    return key === '' ? BlogUserModel.fromJSON(value) : value;
  }
}
